// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"cdfc9027","507":"03357613","878":"08cfda4f"}[chunkId] + ".chunk.css";
};